import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import every from 'lodash/every';
import bindAll from 'lodash/bindAll';
import isEmpty from 'lodash/isEmpty';
import analytics from '@nerdwallet/analytics';
import { Impression, ImpressionContext } from '@nerdwallet/analytics/react/impression';
import Popover from '@nerdwallet/react-popover';
import Plus from '@nerdwallet/react-icon/gizmo/Plus';
import Delete from '@nerdwallet/react-icon/gizmo/Delete';
import Navigateleft from '@nerdwallet/react-icon/gizmo/Navigateleft';
import Button from '@nerdwallet/react-button';
import CreditCardSearch from '@nerdwallet/credit-card-search';
import Modal from '@nerdwallet/react-modal';
import { createCard } from '@nerdwallet/cc-utils/lib/offer-api/offer-api';
import { createOfferPayload } from '@nerdwallet/nw-api-sdk/dist/offer-sdk/credit-cards';
import { ElementInteraction } from '@nerdwallet/nw-client-lib/tracking';
import { getLegacyId, getImageAltText, getName } from '@nerdwallet/marketplace/selectors/credit-cards';
import { getImageBySize } from '@nerdwallet/marketplace/utils';
import './compare-add-button.less';
var GENERIC_CARD_IMG = 'https://www.nerdwallet.com/cdn/cc/cc_generic_bw.png';

var CompareAddButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CompareAddButton, _React$Component);

  var _super = _createSuper2(CompareAddButton);

  function CompareAddButton(props) {
    var _this;

    _classCallCheck(this, CompareAddButton);

    _this = _super.call(this, props);
    _this.state = {
      selectedCards: [],
      isOpen: false
    };
    bindAll(_assertThisInitialized(_this), 'onAddClick', 'closeModal', 'handleModalDone', 'handleCardSelected', 'removeCardFromModal');
    return _this;
  }

  _createClass(CompareAddButton, [{
    key: "onAddClick",
    value: function onAddClick(impressionId) {
      if (this.props.analytics.enabled && impressionId) {
        analytics.track("element_interacted", {
          action: "select",
          entity_name: "cc_add_to_compare",
          impression_id: impressionId,
          interaction_type: "press"
        });
      }

      this.setState({
        selectedCards: [],
        isOpen: true
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal(e) {
      var formClosedEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "form_cancelled";

      if (this.props.analytics.enabled) {
        analytics.track(formClosedEvent, {
          form_name: "cc_add_to_compare"
        });
      }

      this.setState({
        isOpen: false
      });
    }
  }, {
    key: "handleModalDone",
    value: function handleModalDone(e) {
      var _this2 = this;

      var selectedCards = this.state.selectedCards;
      var newCards = selectedCards.filter(function (card) {
        return !_this2.props.cardsToCompare[getLegacyId(card)];
      });

      if (newCards.length) {
        var emptyPayload = createOfferPayload();
        this.props.saveToCompare({
          cards: newCards.map(function (cardObj) {
            return createCard(cardObj, emptyPayload);
          }),
          productLocation: 'compare-add-modal'
        });
      }

      this.closeModal(e, "form_submitted");
    }
  }, {
    key: "handleCardSelected",
    value: function handleCardSelected(cardId, card) {
      if (!isEmpty(card)) {
        var selectedCards = this.state.selectedCards;

        if (every(selectedCards, function (selectedCard) {
          return getLegacyId(selectedCard) !== cardId;
        })) {
          if (this.props.analytics.enabled) {
            analytics.track("cc_add_to_compare_card_updated", {
              form_name: "cc_add_to_compare",
              value_s: card === null || card === void 0 ? void 0 : card.id,
              was_prefilled: false
            });
          }

          this.setState({
            selectedCards: [].concat(_toConsumableArray(selectedCards), [card])
          });
        }
      }
    }
  }, {
    key: "removeCardFromModal",
    value: function removeCardFromModal(card) {
      var cardId = getLegacyId(card);

      if (this.props.analytics.enabled) {
        analytics.track("cc_add_to_compare_card_crossed_out", {
          form_name: "cc_add_to_compare",
          was_prefilled: true,
          value_s: card === null || card === void 0 ? void 0 : card.id
        });
      }

      this.setState({
        selectedCards: _toConsumableArray(this.state.selectedCards.filter(function (selectedCard) {
          return getLegacyId(selectedCard) !== cardId;
        }))
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var popoverContent = React.createElement("span", null, "Add a card");
      return React.createElement(ImpressionContext.Consumer, null, function (value) {
        var _this3$props$analytic, _this3$props$analytic2;

        return React.createElement("div", {
          className: "add-card-container"
        }, React.createElement(Popover, {
          type: ['hover'],
          popoverContent: popoverContent,
          placement: "top",
          className: "popover-overlay-trigger",
          popoverClassName: "card-image-popover-add",
          key: "compare-card-image-add",
          id: "compare-card-image-add"
        }, React.createElement(ElementInteraction, {
          type: "CLICK",
          id: "compare-bar-add-card-image",
          elementName: "compare-bar-add-card-image",
          sectionCategory: "compare-bar"
        }, React.createElement("button", {
          className: "card-image card-image-add",
          onClick: function onClick() {
            return _this3.onAddClick(value === null || value === void 0 ? void 0 : value.impressionId);
          }
        }, React.createElement("div", {
          className: "bar"
        }), React.createElement(Plus, {
          className: "icon plus"
        })))), React.createElement(Modal, {
          isOpen: _this3.state.isOpen,
          onRequestClose: _this3.closeModal
        }, React.createElement(Impression, {
          entityName: "cc_add_to_compare",
          enabled: _this3.props.analytics.enabled,
          eventType: "form_impression",
          payload: {
            section_name: (_this3$props$analytic = _this3.props.analytics) === null || _this3$props$analytic === void 0 ? void 0 : (_this3$props$analytic2 = _this3$props$analytic.payload) === null || _this3$props$analytic2 === void 0 ? void 0 : _this3$props$analytic2.sectionName,
            form_name: "cc_add_to_compare"
          }
        }, React.createElement("div", {
          className: "compare-add-card-modal-content"
        }, React.createElement("h3", null, "Which card would you like to compare?"), React.createElement(CreditCardSearch, {
          onClick: _this3.handleCardSelected,
          offerSDK: _this3.props.offerSDK,
          marketplaceSDK: _this3.props.marketplaceSDK
        }), _this3.state.selectedCards.map(function (card, i) {
          return React.createElement("div", {
            className: "pre-select-card__selected-card",
            key: "selected-card-".concat(i)
          }, React.createElement("div", null, React.createElement("img", {
            className: classnames('pre-select-card__selected-img'),
            src: getImageBySize(card) || getImageBySize(card, 'medium') || getImageBySize(card, 'large') || GENERIC_CARD_IMG,
            alt: getImageAltText(card)
          })), React.createElement("div", {
            className: "card-title",
            dangerouslySetInnerHTML: {
              __html: getName(card)
            }
          }), React.createElement("button", {
            className: "remove-from-compare",
            onClick: function onClick() {
              _this3.removeCardFromModal(card);
            }
          }, React.createElement(Delete, {
            className: "icon delete"
          })));
        }, this), React.createElement("div", {
          className: "compare-modal-navigation"
        }, React.createElement(ElementInteraction, {
          type: "CLICK",
          id: "compare-bar-modal-back",
          elementName: "compare-bar-modal-back",
          sectionCategory: "compare-bar-add-modal"
        }, React.createElement("button", {
          className: "back-button",
          onClick: _this3.closeModal
        }, React.createElement("span", null, React.createElement(Navigateleft, {
          className: "icon navigateleft"
        }), "Back"))), React.createElement(Button, {
          primary: true,
          className: "done-button",
          onClick: _this3.handleModalDone
        }, "Done"))))));
      });
    }
  }]);

  return CompareAddButton;
}(React.Component);

_defineProperty(CompareAddButton, "propTypes", {
  analytics: PropTypes.shape({
    enabled: PropTypes.bool,
    payload: PropTypes.shape({
      sectionName: PropTypes.string
    })
  }),
  saveToCompare: PropTypes.func.isRequired,
  cardsToCompare: PropTypes.objectOf(PropTypes.object),
  offerSDK: PropTypes.shape({}).isRequired,
  marketplaceSDK: PropTypes.shape({}).isRequired
});

_defineProperty(CompareAddButton, "defaultProps", {
  analytics: {
    enabled: false
  },
  cardsToCompare: {}
});

export { CompareAddButton as default };
//# sourceMappingURL=compare-add-button.js.map